import { PropsWithChildren } from 'react';
import styled from 'styled-components';

import { getFontColor, themeable } from './utils/colors';

type NotificationProps = PropsWithChildren<{
  $color?: string;
}>;

const StyledNotification = styled.div<NotificationProps>`
  border-radius: 4px;
  background-color: ${({ theme, $color }) =>
    themeable(theme, $color) || theme.colors.N60};
  color: ${({ theme, $color }) =>
    getFontColor(themeable(theme, $color) || theme.colors.N60)};
  padding: 0.6em 1.4em;
`;

function Notification({ $color, children, ...rest }: NotificationProps) {
  return (
    <StyledNotification $color={$color} {...rest}>
      {children}
    </StyledNotification>
  );
}

export default Notification;
